type CertificationStepInput = {
  certificationStatus: string;
  totalErrors: number;
  hasLockedRevision: boolean;
  allReportsVerified?: boolean;
};

type CertificationStepResult = {
  certificationStep: string;
  isResolvingErrors: boolean;
  isVerifyingReports: boolean;
  isReadyForCertification: boolean;
  isCertified: boolean;
  isDecertified: boolean;
};

export function useCertificationStep({
  certificationStatus,
  totalErrors,
  hasLockedRevision,
  allReportsVerified = false,
}: CertificationStepInput): CertificationStepResult {
  if (certificationStatus === "Certified") {
    return {
      certificationStep: "Certified",
      isResolvingErrors: false,
      isVerifyingReports: false,
      isReadyForCertification: false,
      isCertified: true,
      isDecertified: false,
    };
  }

  const isDecertified = certificationStatus === "Decertified";

  // Step 1: Fatal errors block progress
  if (totalErrors > 0) {
    return {
      certificationStep: "Resolve Fatal Errors",
      isResolvingErrors: true,
      isVerifyingReports: false,
      isReadyForCertification: false,
      isCertified: false,
      isDecertified,
    };
  }

  //   Step 2: Reports must be verified
  if (!allReportsVerified || !hasLockedRevision) {
    return {
      certificationStep: "Verify Reports",
      isResolvingErrors: false,
      isVerifyingReports: true,
      isReadyForCertification: false,
      isCertified: false,
      isDecertified,
    };
  }

  // Step 3: All clear — ready to certify
  return {
    certificationStep: "Ready for Certification",
    isResolvingErrors: false,
    isVerifyingReports: false,
    isReadyForCertification: true,
    isCertified: false,
    isDecertified,
  };
}
